import { Navigate, Outlet } from "react-router-dom";
import { logger, useAuth } from "../core";
import { toastService } from "@/core/services/toast.service";
import { useAppDispatch } from "@/store/hooks";
import { clearUser } from "@/store/slices/auth";
const ProtectedRoutes = () => {
  const dispatch = useAppDispatch();
  const {
    // isLoading,
    error,
    isError,
    isSuccess,
    data: sessionResponse,
  } = useAuth();
  logger.warn("data from get session ===> useAuth() ", sessionResponse);
  if (isError) {
    toastService.error("Not Found", error?.message as string);
    dispatch(clearUser());
    return <Navigate to="login" />;
  }
  if (isSuccess) {
    return <Outlet />;
  }
};
export default ProtectedRoutes;
